var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleThumbUpOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 117.3 84",
    style: {
      enableBackground: "new 0 0 117.3 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.6,29.5H47.2v-6C47.2,15.3,41,9,32.6,9h-1.3c-2.2,0-3.7,1.5-4.5,2.9l-7,17.7h-1.3C9.3,29.5,2,36.8,2,46v20.6 C2,75.7,9.3,83,18.5,83h8.2h33.9c8.2,0,15.9-6.4,17.4-14.5l3.7-20.8C83.5,37.7,76.8,29.5,66.6,29.5z M18.5,74.8 c-5.1,0-8.2-3.1-8.2-8.2V46c0-5.1,3.1-8.2,8.2-8.2V74.8z M73.7,46.3L70,67.1c-0.9,4.6-4.5,7.7-9.4,7.7H26.7V34.5l6.8-17.2 c3.7,0.3,5.5,2.3,5.5,6.3V33c0,2.7,2.1,4.7,4.7,4.7h22.8C72.3,37.8,74.7,40.7,73.7,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,21.7h-18c-0.7,0-1.3-0.6-1.3-1.3v-3.3c0-8.8-7.1-15.9-15.9-15.9c-2.1,0-3.6,1.5-4.5,2.8c0,0.1-0.1,0.2-0.1,0.2 L53.3,20c-0.2,0.6,0,1.2,0.5,1.6c1.6,1.1,3.4,2.2,5.2,2.9c0.7,0.3,1.5-0.1,1.8-0.7l5.3-13.3c0.2-0.6,0.9-1,1.5-0.8 c2.9,0.6,4.4,2.5,4.4,6.1v8.1c0,3.4,2.7,6.1,6.1,6.1h17.5c5.8,0,8.1,2.9,7.1,8.5l-3.7,20.8c-0.9,4.6-4.5,7.7-9.4,7.7h-5.6 c-0.7,0-1.3,0.6-1.3,1.4c0,1.8,0,3.7,0,5.5c0,0.7,0.6,1.3,1.3,1.3h9.6c8.2,0,11.9-6.4,13.4-14.5l3.7-20.8 C112.5,29.8,109.7,21.7,99.5,21.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleThumbUpOutlined);
export default __webpack_public_path__ + "static/media/double_thumb_up_outlined.f7d50c8c.svg";
export { ForwardRef as ReactComponent };